export const SET_STATE = 'adverts/SET_STATE';
export const SET_FETCHING = 'adverts/SET_FETCHING';
export const SET_ADVERTS = 'adverts/SET_ADVERTS';
export const SET_FILTERED_ADVERTS = 'adverts/SET_FILTERED_ADVERTS';
export const RESET_STATE = 'adverts/RESET_STATE';
